import { Reducer } from "redux";

import { FAQAction, FAQActionTypes, FAQState } from "./types";

const initialState: FAQState = {
  categories: [],
  isArticleLoading: false,
  isCategoriesLoading: false,
};

const reducer: Reducer<FAQState, FAQAction> = (state = initialState, action) => {
  switch (action.type) {
    case FAQActionTypes.CATEGORIES_FETCH_REQUEST: {
      return { ...state, isCategoriesLoading: true };
    }

    case FAQActionTypes.CATEGORIES_FETCH_ERROR: {
      return { ...state, isCategoriesLoading: false };
    }

    case FAQActionTypes.CATEGORIES_FETCH_SUCCESS: {
      const { items } = action.payload;
      return { ...state, isCategoriesLoading: false, categories: items };
    }

    case FAQActionTypes.ARTICLE_FETCH_REQUEST: {
      return { ...state, isArticleLoading: true };
    }

    case FAQActionTypes.ARTICLE_FETCH_ERROR: {
      return { ...state, isArticleLoading: false };
    }

    case FAQActionTypes.ARTICLE_FETCH_SUCCESS: {
      return { ...state, isArticleLoading: false, article: action.payload };
    }

    default:
      return state;
  }
};

export default reducer;
